import Plotly from "plotly.js-dist/plotly";

export default function (_, inject) {
  inject("Plotly", Plotly);
}
